import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface Prop {
  yellow?: boolean
  error?: boolean | string
}

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;

  .new-token-container {
    display: flex;
    flex-wrap: wrap;
    margin-top: 24px;
    width: 100%;

    gap: 12px 24px;
  }

  .new-token-div-juros {
    display: flex;
    justify-content: space-around;

    width: 250px;
  }

  .new-token-plus {
    margin-top: 12px;
    color: var(--Cinza-claro, #9c948c);
    text-align: center;

    /* A - Link ou legendas - Light */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
  }
`
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  height: 100%;

  .red-icon {
    filter: invert(13%) sepia(77%) saturate(7263%) hue-rotate(0deg)
      brightness(98%) contrast(114%);
    height: 18px;
    width: 18px;
  }
  .row {
    display: flex;
    width: 100%;
  }
  .big-red-title {
    font-size: 18px;
    font-weight: 700;
    text-align: left;
    color: #df7a58;
    margin: 0 0 24px 10px;
  }
  .black-title {
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    margin: 0 0 8px 0;
    color: #1c1d22;
  }
  .black-content {
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    margin: 0 0 32px 0;
    color: #1c1d22;
  }
`
export const Button = styled.button`
  border-radius: 20px;
  padding: 14px 16px;
  /* min-width: 130px; */
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  font-family: Inter;
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  background-color: transparent;
  border: ${(props: any) => {
    if (props.yellow) return '2px solid #FFC600'
    return '2px solid #1C1D22'
  }};
  color: ${(props: any) => {
    if (props.yellow) return '#FFC600'
    return '#1C1D22'
  }};
  &:hover {
    color: #ffffff;
    background-color: ${(props: Prop) => {
      if (props.yellow) return '#FFC600'
      return '#1C1D22'
    }};
  }
  cursor: pointer;
  .icon {
    margin-right: 10px;
    height: 18px;
    width: 18px;
    filter: ${(props: Prop) => {
      if (props.yellow)
        return 'invert(70%) sepia(61%) saturate(1093%) hue-rotate(0deg) brightness(104%) contrast(104%);'
      return 'none'
    }};
  }
  &:hover .icon {
    filter: invert(95%) sepia(96%) saturate(0%) hue-rotate(137deg)
      brightness(105%) contrast(103%);
  }
`

export const FeedbackContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .close-modal {
    width: 24px;
    height: 24px;
    justify-self: flex-start;
    align-self: flex-end;
  }
  .title-res {
    margin-top: 15px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    color: ${(props: Prop) => {
      if (props.error) return '#DC5D6C'
      return '#DF7A58'
    }};
  }

  .error-msg {
    margin-top: 8px;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #dc5d6c;
  }

  .confirm-img {
    width: 100px;
    height: 100px;
  }
`
